import env from "app/utils/env";

export const hasEmptyParams = url => {
	const searchParams = new URLSearchParams(new URL(url).search);
	let isEmpty = false;
	for (let value of searchParams.values()) {
		if (!value) {
			isEmpty = true;
			break;
		}
	}
	return isEmpty;
};

export const isRequestAborted = response => {
	return response?.code === "ERR_CANCELED";
};

export const removeTrailingSlash = url => {
	const cleanUrl = url.replace(/\/$/, "");

	return cleanUrl;
};

export const isTargetApiUrl = url => {
	if (!url) {
		return false;
	}

	const hotelOnlyApiUrl = env("HOTEL_ONLY_API_URL");
	const quoteApiUrl = env("QUOTE_API_URL");

	return (
		(hotelOnlyApiUrl && url.startsWith(hotelOnlyApiUrl)) ||
		(quoteApiUrl && url.startsWith(quoteApiUrl)) ||
		false
	);
};

const ANCHOR_TAG_PATTERN = /<a\b[^>]*>/gi;
const HREF_ATTRIBUTE_PATTERN = /(\shref\s*=\s*)(?:"([^"]*)"|'([^']*)'|([^\s"'=<>`]+))/i;

/**
 * Rewrites root-relative `href` values of `<a>` tags in a rich text HTML string so they keep
 * the current microsite prefix (e.g. "/holidays") when not already part of the CMS-authored URL.
 */
export const prefixInternalRichTextLinks = (html, prefix) => {
	if (!html || !prefix) {
		return html;
	}

	const normalizedPrefix = removeTrailingSlash(prefix);

	return html.replace(ANCHOR_TAG_PATTERN, anchorTag =>
		anchorTag.replace(
			HREF_ATTRIBUTE_PATTERN,
			(match, hrefPart, doubleQuoted, singleQuoted, unquoted) => {
				const quote =
					doubleQuoted !== undefined ? '"' : singleQuoted !== undefined ? "'" : "";
				const value = doubleQuoted ?? singleQuoted ?? unquoted;
				const isRootRelative = value.startsWith("/") && !value.startsWith("//");
				const isAlreadyPrefixed =
					value === normalizedPrefix || value.startsWith(`${normalizedPrefix}/`);

				if (!isRootRelative || isAlreadyPrefixed) {
					return match;
				}

				return `${hrefPart}${quote}${normalizedPrefix}${value}${quote}`;
			}
		)
	);
};
